import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('field' + (_ctx.is50Width ? ' split-width': ''))
  }, [
    _createElementVNode("label", {
      class: _normalizeClass(_ctx.isCheckBox? 'checkbox': '')
    }, [
      (_ctx.label && !_ctx.isCheckBox)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.label) + _toDisplayString(_ctx.required ? '*': ''), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (_ctx.label && _ctx.isCheckBox)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "text",
            innerHTML: (_ctx.label+(_ctx.required ? '*': ''))
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}